import script from "./NotificationsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationsComponent.vue?vue&type=script&setup=true&lang=js"

import "./NotificationsComponent.vue?vue&type=style&index=0&id=085cb8a2&lang=scss"

const __exports__ = script;

export default __exports__